<template>
  <div class="watermark" v-if="role !== 'CLIENT'">
    <div class="container">
      <div class="ribbon text-center" :class="status ? 'success' : 'error'">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Watermark",
  props: {
    text: {
      default: "PAUSED",
    },
    status: {
      default: false,
    },
  },
  computed: {
    ...mapGetters(["role"]),
  },
};
</script>

<style lang="scss" scoped>
*:hover > .watermark {
  pointer-events: none;
  opacity: 0;
}
.watermark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 1;
  overflow: hidden;
  transition: 0.25s;
}
.container {
  position: absolute;
  left: 1.5em;
  top: 1.5em;
  z-index: 1;
  color: #fff;
  text-align: center;
  width: auto;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  .ribbon {
    position: absolute;
    transform: rotateZ(-45deg);
    width: 10em;
    font-size: 0.75em;
    line-height: 1.5em;
  }
}
</style>
